import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
// import moment from 'moment';

import SCREENSHOTS from '../../data/screenshots';
import Lightbox from './Lightbox';
import { minWidth } from '../../helpers/media-queries';

import config from '../../data/config';

const styles = ({ palette, sizes }) => ({
  root: {
    padding: '15px 25px 0',
    '& button': {
      background: 'none',
      border: 'none',
      padding: '8px',
      cursor: 'pointer',
      '&:nth-child(3n + 2)': {
        marginTop: '0',
      },
      '&:focus, &:active': {
        border: 'none',
      },
      [minWidth.md]: {
        marginTop: '-50px',
      },
    },
  },

  img: {
    diplay: 'flex',
    flex: 1,
    width: '100%',
    border: '4px solid #15252c',
  },
});

const mapper = (stores, props) => ({
  intl: stores.intl.dictionary,
  modal: stores.screenshots._screenshot,
  setScreenshot: (id) => stores.screenshots.setScreenshot(id),
});

class Gallery extends Component {
  // timestamp = moment().format('YYYYMMDDhh');

  render() {
    const { classes } = this.props;
    return (
      <div className={classNames('row', classes.root)}>
        {[...this._generateImages(SCREENSHOTS)]}
        {this._renderModal()}
      </div>
    );
  }

  *_generateImages(content, type) {
    content = content || [];
    content = content.entries();

    for (const [i, entry] of content) {
      yield this._renderImage(`screenshot-${type}-${i}`, entry);
    }
  }

  _renderImage(key, content) {
    const { setScreenshot, classes, intl } = this.props;

    const timestamp = config.version ? config.version.replace(/\./gi, '') : '';

    // Keep references to named entries
    let ref = this.refs[key];
    if (!ref) {
      ref = React.createRef();
      this.refs = Object.assign({}, this.refs, { [key]: ref });
    }

    return (
      <button
        key={key}
        ref={ref}
        className="col-md-4"
        aria-label={intl[content.aria.label]}
        onClick={() => setScreenshot(content.id)}
      >
        <img
          src={`${content.src}?${timestamp}`}
          className={classes.img}
          alt={intl[content.aria.label]}
          title={intl[content.aria.label]}
        />
      </button>
    );
  }

  _renderModal = () => {
    const { modal } = this.props;
    return <Lightbox open={!!modal} />;
  };

  _handleModal = (id) => {
    this.setState({ id });
  };
}

export default inject(mapper)(withStyles(styles)(Gallery));
